import React from 'react'

const ToggleCard = ({ title, description, enabled, onToggle }) => {
    return (
        <div className="toggle-card">
            <div className="toggle-card-header">
                <div>
                    <p className="toggle-card-title">{title}</p>
                    <p className="toggle-card-text">{description}</p>
                </div>

                <button
                    type="button"
                    onClick={onToggle}
                    className={`switch ${enabled ? "switch--on" : ""}`}
                >
                    <span className="switch-thumb" />
                </button>
            </div>
        </div>
    );
}

export default ToggleCard